(function () {
  function moneyFmt(cents) {
    var val = (cents / 100).toFixed(2);
    return (window.Shopify && Shopify.currency && Shopify.currency.active) ? val + ' ' + Shopify.currency.active : val;
  }

  function ensureModal() {
    var existing = document.getElementById('pc-qv-overlay');
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.id = 'pc-qv-overlay';
    overlay.className = 'pc-qv-overlay';
    overlay.innerHTML =
      '<div class="pc-qv-modal" role="dialog" aria-modal="true">' +
        '<button type="button" class="pc-qv-close" aria-label="Close">&times;</button>' +
        '<div class="pc-qv-media"><div class="pc-qv-loading">Loading...</div></div>' +
        '<div class="pc-qv-body">' +
          '<h3 class="pc-qv-title"></h3>' +
          '<div class="pc-qv-price-row"><span class="pc-qv-compare"></span><span class="pc-qv-price"></span></div>' +
          '<div class="pc-qv-qty-label">Language</div>' +
          '<div class="pc-qv-tiers"></div>' +
          '<button type="button" class="pc-qv-atc">Add to Cart</button>' +
          '<a href="#" class="pc-qv-viewfull">View Full Details &rsaquo;</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.pc-qv-close')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
    return overlay;
  }

  function closeModal() {
    var overlay = document.getElementById('pc-qv-overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function openModal(handle) {
    var overlay = ensureModal();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var media = overlay.querySelector('.pc-qv-media');
    var title = overlay.querySelector('.pc-qv-title');
    var price = overlay.querySelector('.pc-qv-price');
    var compare = overlay.querySelector('.pc-qv-compare');
    var tiersWrap = overlay.querySelector('.pc-qv-tiers');
    var atc = overlay.querySelector('.pc-qv-atc');
    var viewFull = overlay.querySelector('.pc-qv-viewfull');

    media.innerHTML = '<div class="pc-qv-loading">Loading...</div>';
    title.textContent = '';
    tiersWrap.innerHTML = '';

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        title.textContent = product.title;
        viewFull.href = product.url;

        if (product.featured_image) {
          media.innerHTML = '<img src="' + product.featured_image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_1000x$2') + '" alt="' + product.title.replace(/"/g, '') + '">';
        } else {
          media.innerHTML = '<svg viewBox="0 0 100 100"><rect width="100" height="100" fill="#fdeef2"/><circle cx="50" cy="50" r="20" fill="none" stroke="#d85f88" stroke-width="3"/></svg>';
        }

        var variants = product.variants || [];
        var selectedVariant = variants.find(function (v) { return v.available; }) || variants[0];

        function renderPrice() {
          if (!selectedVariant) return;
          price.textContent = moneyFmt(selectedVariant.price);
          compare.textContent = (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price)
            ? moneyFmt(selectedVariant.compare_at_price)
            : '';
        }

        function renderTiers() {
          tiersWrap.innerHTML = '';
          variants.forEach(function (v) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'pc-qv-tier' + (selectedVariant && v.id === selectedVariant.id ? ' is-selected' : '');
            btn.textContent = v.option1 || v.title;
            if (!v.available) btn.disabled = true;
            btn.addEventListener('click', function () {
              selectedVariant = v;
              renderTiers();
              renderPrice();
            });
            tiersWrap.appendChild(btn);
          });
        }

        renderTiers();
        renderPrice();

        atc.onclick = function () {
          if (!selectedVariant) return;
          atc.disabled = true;
          var originalText = atc.textContent;
          atc.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: selectedVariant.id, quantity: 1 }] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('add failed');
              return res.json();
            })
            .then(function () {
              atc.textContent = 'Added!';
              setTimeout(function () {
                closeModal();
                atc.disabled = false;
                atc.textContent = originalText;
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                if (window.PCCartDrawer) {
                  window.PCCartDrawer.open();
                } else {
                  window.location.href = '/cart';
                }
              }, 400);
            })
            .catch(function () {
              atc.disabled = false;
              atc.textContent = originalText;
              window.location.href = product.url;
            });
        };
      })
      .catch(function () {
        media.innerHTML = '<div class="pc-qv-loading">Could not load this product.</div>';
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quickview-handle]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    openModal(trigger.getAttribute('data-quickview-handle'));
  });
})();
